export default __webpack_public_path__ + "static/media/colmena.85d3ce99.svg";